// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subnav .active{background-color:#ccc !important}`, "",{"version":3,"sources":["webpack://./src/frontend/components/molecules/compare-toolbar/styles.compare-toolbar.scss"],"names":[],"mappings":"AACE,gBACE,gCAAA","sourcesContent":[".subnav {\n  .active {\n    background-color: #ccc !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
